import {
    // createMemoryHistory,
    // createBrowserHistory,
    createHashHistory,
} from 'history'

// const history = createMemoryHistory()
// const history = createBrowserHistory()
const history = createHashHistory()

export default history
